export const CREATE = "create";
export const UPDATE = "update";
export const READ = "read";
export const DELETE = "delete";

export const WASHROOM_TYPES = ["Patient", "Staff", "Visitor", "Other"];

////////////MODULE KEYS////////
export const USER_MODULE = "userManagement";
export const DEPARTMENTS = "departments";
export const ROLES_MODULE = "roleManagement";
export const REGION_MODULE = "regions";
export const PREMISES_MODULE = "premises";

export const POLICY_TAGS = "policyTags";
export const FIRERISK_PROCESSES = "fireriskProcesses";
export const FIRERISK_SUB_PROCESSES = "fireriskSubprocess";
export const BUDGET_CATEGORIES = "budgetCategories";
export const LECCAL_CONTRACT_TYPES = "legalContractTypes";
export const SUPPLIERS = "suppliersDetails";
export const ASSETS_EQUIPMENT = "assetsModule";
export const WASHROOM_CHECKLIST_CATEGORY = "washroomChecklistCategory";
export const WASHROOM_TYPES_LIST = "washroomTypesList";
export const EMERGENCY_CATEGORY = "emergencyCategory";
export const EMERGENCY_SUB_CATEGORY = "emergencySubCategory";
export const EQUIPMENT_CATEGORY = "equipmentCategory";
export const EQUIPMENT_SUB_CATEGORY = "equipmentSubCategory";

/////////////////////////////////////////
export const FS_DASHBOARD_MODULE = "firesystemDashboard";
export const TASK__MODULE = "taskManagement";
export const POLICY_MODULE = "policiesAndManuals";
export const RISKASSES_MODULE = "riskAssessmentPlan";
export const BUDGET_MODULE = "budgetingPlan";
export const ASSETS_MODULE = "assetsModule";
export const TRAINING_MODULE = "trainingModule";
export const FIREDRILL_MODULE = "fireDrillsModule";
export const MONITORING_MODULE = "fireSystemMonitoring";
export const SAFETYAUDIT_MODULE = "fireSafetyAudits";
export const INCIDENTS_MODULE = "incidentModule";
export const FIRE_INCIDENT_INVESTIGATION_MODULE = "fireIncidentInvestigation";
/* export const DATA_ANALYSIS_MODULE = "dataAnalysisModule";
 */
//////////
export const INCIDENT_DASHBOARD = "incidentDashboard";
export const INCIDENT_LIST = "incidentsList";
export const INCIDENT_REPORTS = "incidentReports";

// Washroom Management Modules
export const WASHROOM_MANAGEMENT = "washroomManagement";
export const WASHROOM_DASHBOARD = "washroomDashboard";
export const WASHROOM_CHECKLISTS = "washroomChecklists";
export const WASHROOM_AUDITS = "washroomAudits";
export const WASHROOM_REPORTS_ANALYTICS = "washroomReportsAnalytics";
export const WASHROOM_ISSUES_REPORTS = "washroomIssuesReports";

// laws and regulations Modules
export const LAWS_REGULATIONS_MODULE = "laws_regulations";
export const LAWS_REGULATIONS_FACILITY_INFORMATION =
  "laws_regulations_facility_information";
//////////////////////////
export const LAWS_REGULATIONS_DASHBOARD = "lawsRegulationsDashboard";
export const LAWS_REGULATIONS_POLICIES = "lawsRegulationsPolicies";
export const LAWS_REGULATIONS_AUDITS = "lawsRegulationsAudits";
export const LAWS_REGULATIONS_TASKS = "lawsRegulationsTasks";
export const LAWS_REGULATIONS_PREMISES_INFO = "lawsRegulationsPremisesInfo";
export const LAWS_REGULATIONS_STAFF_MANAGEMENT = "lawsRegulationsStaff";

// Equipment Management Modules
export const EQUIPMENT_MANAGEMENT_MODULE = "equipmentManagement";
export const EQUIPMENT_MANAGEMENT_TASKS = "equipmentTasks";
export const EQUIPMENT_MANAGEMENT_EQUIPMENT_INVENTORY_REGISTRATION =
  "equipmentInventoryRegistration";
export const EQUIPMENT_MANAGEMENT_DOCUMENTATION_AND_HISTORY =
  "documentationAndHistory";
export const EQUIPMENT_MANAGEMENT_MAINTENANCE_SCHEDULING_AND_TRACKING =
  "maintenanceSchedulingAndTracking";
export const EQUIPMENT_MANAGEMENT_TRAINING_EVALUATION =
  "EquipmentManagementTrainingEvaluation";
export const EQUIPMENT_MANAGEMENT_CREATE_TRAINING = "createTraining";
export const EQUIPMENT_MANAGEMENT_TRAINING_DASHBOARD = "trainingDashboard";
export const EQUIPMENT_MANAGEMENT_TRAINING_UPCOMING_SESSIONS =
  "upcomingSessions";
export const EQUIPMENT_MANAGEMENT_TRAINING_PAST_EVALUATIONS = "pastEvaluations";
export const EQUIPMENT_MANAGEMENT_TRAINING_VIEW = "trainingView";
export const EQUIPMENT_MANAGEMENT_TRAINING_UPCOMING_SESSION_DETAILS =
  "upcomingSessionDetails";
export const EQUIPMENT_MANAGEMENT_REPORT_AND_ANALYTICS = "reportAndAnalytics";
export const EQUIPMENT_MANAGEMENT_INCIDENT = "incidentEquipment";
export const EQUIPMENT_MANAGEMENT_BUDGETING = "budgetingEquipment";

// Hazardous Materials Modules
export const HAZARDOUS_MATERIALS_MODULE = "hazardousMaterials";
export const HAZARDOUS_MATERIALS_INVENTORY = "hazardousMaterialInventory";
export const HAZARDOUS_MATERIALS_SAFETY_COMPLIANCE =
  "hazardousMaterialSafetyCompliance";
export const HAZARDOUS_MATERIALS_STORAGE_HANDLING =
  "hazardousMaterialStorageHandling";
export const HAZARDOUS_MATERIALS_TRACKING_MOVEMENT =
  "hazardousMaterialTrackingMovement";
export const HAZARDOUS_MATERIALS_INCIDENT_AND_SPILL =
  "hazardousMaterialIncidentAndSpill";
export const HAZARDOUS_MATERIALS_INSPECTION_COMPLIANCE =
  "hazardousMaterialInspectionCompliance";
export const HAZARDOUS_MATERIALS_DISPOSAL_MANAGEMENT =
  "hazardousMaterialDisposalManagement";
export const HAZARDOUS_MATERIALS_SEARCH_REPORTING =
  "hazardousMaterialSearchReporting";
export const HAZARDOUS_MATERIALS_WASTE = "hazardousMaterialWaste";
export const HAZARDOUS_MATERIALS_POLICIES_MANUALS =
  "hazardousMaterialPoliciesManuals";
export const HAZARDOUS_MATERIALS_TRAINING_EVALUATION =
  "hazardousMaterialTrainingEvaluation";
export const HAZARDOUS_MATERIALS_TESTING_DRILLS =
  "hazardousMaterialTestingDrills";
export const HAZARDOUS_MATERIALS_AUDITS = "hazardousMaterialAudits";

// External Emergency Preparedness Modules
export const EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD =
  "externalEmergencyPreparednessDashboard";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_EMERGENCY_RESPONSE_PLANS =
  "externalEmergencyPreparednessEmergencyResponsePlans";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY =
  "externalEmergencyPreparednessBusinessContinuityRecovery";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_TESTING_DRILLS =
  "externalEmergencyPreparednessTestingDrills";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_RISK_ASSESSMENT =
  "externalEmergencyPreparednessRiskAssessment";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_HAZARD_AND_VULNERABILITY_ASSESSMENT =
  "externalEmergencyPreparednessHazardAndVulnerabilityAssessment";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_TRAINING_EVALUATION =
  "externalEmergencyPreparednessTrainingEvaluation";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_EXTERNAL_AGENCIES_COORDINATION =
  "externalEmergencyPreparednessExternalAgenciesCoordination";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_RESOURCE_FOR_READINESS =
  "externalEmergencyPreparednessResourceForReadiness";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_ICS =
  "externalEmergencyPreparednessICS";
export const EXTERNAL_EMERGENCY_PREPAREDNESS_INCIDENTS =
  "externalEmergencyPreparednessIncidents";
// Utility Systems Modules
export const UTILITY_SYSTEMS_DASHBOARD = "utilitySystemsDashboard";
export const UTILITY_SYSTEMS_ASSET_INVENTORY_TRACKING =
  "utilitySystemsAssetInventoryTracking";
export const PREVENTIVE_PREDICTIVE_MAINTENANCE =
  "preventivePredictiveMaintenance";
export const PROJECT_PLANNING_APPROVALS = "projectPlanningApprovals";
export const BUDGETING_COST_CONTROL = "budgetingCostControl";
export const INFECTION_CONTROL_SAFETY_PLANNING =
  "infectionControlSafetyPlanning";

export const UTILITY_ASSET_TYPE_LIST = "utilityAssetTypeList";
export const UTILITY_SYSTEMS_COMPLIANCE_SAFETY =
  "utilitySystemsComplianceSafety";
export const UTILITY_SYSTEMS_SPACE_MANAGEMENT = "utilitySystemsSpaceManagement";
export const UTILITY_SYSTEMS_CONTRACTOR_VENDOR_MANAGEMENT =
  "utilitySystemsContractorVendorManagement";
export const UTILITY_SYSTEMS_DESIGN_DOCUMENTATION_INTEGRATION =
  "utilitySystemsDesignDocumentationIntegration";
export const MONITORING_IOT_INTEGRATION = "monitoringIoTIntegration";

// Safety & Facility Rounds Modules
export const SAFETY_FACILITY_ROUNDS_DASHBOARD = "safetyFacilityRoundsDashboard";
export const SAFETY_FACILITY_ROUNDS_PLANNING = "safetyFacilityRoundsPlanning";
export const SAFETY_FACILITY_ROUNDS_CHECKLISTS =
  "safetyFacilityRoundsChecklists";
export const COMPLIANCE_AUDIT_DOCUMENTATION = "complianceAuditDocumentation";
export const SAFETY_ROUNDS_TYPES = "safetyRoundsTypes";
export const SAFETY_FACILITY_ROUNDS_ISSUES = "safetyFacilityRoundsIssues";
export const SAFETY_FACILITY_ROUNDS_NOTIFICATIONS =
  "safetyFacilityRoundsNotifications";
export const SAFETY_FACILITY_ROUNDS_ESCALATION_RULES =
  "safetyFacilityRoundsEscalationRules";
// Security Modules
export const SECURITY_MODULE = "security";
export const SECURITY_DASHBOARD = "securityDashboard";
export const SECURITY_ACCESS_CONTROL = "securityAccessControl";
export const SECURITY_ACCESS_ZONES = "securityAccessZones";
export const SECURITY_ACCESS_ASSIGNMENTS = "securityAccessAssignments";
export const SECURITY_SURVEILLANCE = "securitySurveillance";
export const SECURITY_CAMERAS = "securityCameras";
export const SECURITY_INCIDENTS = "securityIncidents";
export const SECURITY_VISITOR_MANAGEMENT = "securityVisitorManagement";
export const SECURITY_ASSET_SECURITY = "securityAssetSecurity";
export const SECURITY_STAFF_SAFETY = "securityStaffSafety";
export const SECURITY_PARKING = "securityParking";
export const SECURITY_COMPLIANCE_AUDIT = "securityComplianceAudit";
export const SECURITY_REPORTS = "securityReports";

// Task Module Lists
export const TASK_MODULE_LIST_FIRE_SAFETY = [
  {
    value: TASK__MODULE,
    label: "Tasks",
  },
  { value: POLICY_MODULE, label: "Policies & Manuals" },
  { value: RISKASSES_MODULE, label: "Risk Assessment & Plan" },
  { value: BUDGET_MODULE, label: "Budgeting & Plan" },
  { value: ASSETS_MODULE, label: "Assets & Equipment" },
  { value: TRAINING_MODULE, label: "Training Module" },
  { value: FIREDRILL_MODULE, label: "Fire Drills Module" },
  { value: SAFETYAUDIT_MODULE, label: "Fire Safety Audits" },
  { value: INCIDENTS_MODULE, label: "Incident Module" },
];
